import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { FilterByComponent } from '../filter-by/filter-by.component';
import { FormControl } from '@angular/forms';
import { MainService } from '../main.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MultipleSortingDialogComponent } from '../multiple-sorting-dialog/multiple-sorting-dialog.component';
import Swal from 'sweetalert2';
import { ThisReceiver } from '@angular/compiler';
import { log } from 'console';

//import { DataService } from '../services/data.service';

export interface cardConfig {
  mainHeading: string;
  subHeading: string;
  description: string;
  actionAreaLeft: string;
  actionAreaMid: string;

}
export interface Listconfig {
  pf_path: string;
  pf_name: string;
  app_cd: string;
  header?: any;
  functionalities?: string[];
  pageSize?: number;
  pageSizeOptions?: number[];
  filters?: any;
  cards?: cardConfig
  crudconfig: any
}
@Component({
  selector: 'lib-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  @Input() queryParams: any;
  @Input() config: Listconfig;
  @Output() onViewItemEvent = new EventEmitter<any>();
  @Output() onUpdateItemEvent = new EventEmitter<any>();
  currentPage = 1;
  totalItems = 0;
  pageSize = 5;
  pageSizeOptions: any
  dataList: any[] = []; // This will hold the list data
  displayedColumns: string[] = []; // This will hold the column names
  actionColumns: string[] = []; // Define action columns
  act_id = 2;
  columnChecked: { [key: string]: boolean } = {}; // Object to track checked columns
  selectedColumnsControl = new FormControl();

  constructor(private dataService: MainService, private route: ActivatedRoute, private router: Router, public dialog: MatDialog) {
  }
  @ViewChild(MatSort)
  sort!: MatSort;
  dataSource = new MatTableDataSource<any>();
  table_nm: any
  pf_path: any
  pf_name: any
  allColumns: any = []
  tableview: boolean = true;
  cardsObj: any
  cardsview = false;

  async ngOnInit() {

    ////console.log('hiii');
    ////console.log(params);

    this.route.queryParams.subscribe(async (params) => {

      await this.reset()
      //console.log(this.config, params);

      // let obj: any = this.route.snapshot.queryParamMap.get('id');
      if (params.hasOwnProperty('id')) {

        let obj: any = params['id'];
        //console.log(obj);
        let a = window.atob(obj)
        let b = JSON.parse(a);

        this.config = b
        //console.log(b);
        await this.intialSetUp()
      }
   


    })
  }
  async ngOnChanges(changes: SimpleChanges) {
    await this.reset()
    await this.intialSetUp()
    // //console.log(changes)
    // //console.log(this.config)



  }

  async intialSetUp() {
    this.table_nm = this.config?.header?.value
    this.pf_path = this.config.pf_path
    this.pf_name = this.config.pf_name
    this.pageSize = this.config.pageSize || 6;
    this.pageSizeOptions = this.config.pageSizeOptions || [6, 9, 12, 15, 18]
    if (this.config.hasOwnProperty('filters')) {
      this.filterArr = this.config.filters
      //console.log(this.filterArr);
    }

    if (this.config.hasOwnProperty('cards')) {
      this.cardsObj = this.config.cards
      this.cardsview = true;
      this.tableview = false

    }
    await this.getFields();
    await this.getTotalnoofitems()
    await this.getAllData()

  }

  displayedColumnsObj: any

  async getTotalnoofitems() {
    let req_obj: any = new Object()
    req_obj['pf_path'] = this.pf_path
    req_obj['pf_name'] = this.pf_name
    req_obj['app_cd'] = this.config.app_cd
    this.totalItems = 0;
    if (this.filterArr && Object.keys(this.filterArr).length !== 0) {
      req_obj['filter'] = this.filterArr
    }
    //console.log(req_obj, 'req_objss')
    let resp: any = await this.dataService.getListData(req_obj)
    //console.log(resp);
    if (resp['error'] == false) {
      let data = resp['data']
      this.totalItems = resp['data'].length
      //console.log(data);
    }
    else {

    }
  }

  sortcolumns: any
  busnm_by_tech: any
  datatypebytech: any
  dataArr: any
  columnNames: any;
  filteredData=[]

  async getAllData() {
    const req_obj: any = {
      // act_id: this.act_id,
      pf_path: this.pf_path,
      pf_name: this.pf_name,
      app_cd: this.config.app_cd,
      limit: this.pageSize,
      offset: (this.currentPage - 1) * this.pageSize
    };

    if (this.orderArr && this.orderArr.length > 0) {
      req_obj['order'] = this.orderArr
    }
    if (this.filterArr && Object.keys(this.filterArr).length !== 0) {
      req_obj['filter'] = this.filterArr
    }
    if (req_obj.hasOwnProperty('filter') && req_obj.filter !== null && req_obj.filter !== undefined) {
      // this.totalItems=data.length
      await this.getTotalnoofitems()
    }

    //console.log(req_obj);

    const resp: any = await this.dataService.getListData(req_obj);
    if (resp.error == false) {
      const data = resp.data;
      this.dataList = [];
      this.displayedColumns = [];
      this.displayedColumnsObj = {};
      this.sortcolumns = []
      this.busnm_by_tech = {}
      this.datatypebytech = {}

      if (data && data.length > 0) {
        let columns=[]
        this.displayedColumns=[]
     //   //console.log(columns,this.displayedColumns)
         columns = Object.keys(data[0]);
        this.sortcolumns = Array.from(columns);
       // //console.log(columns,this.displayedColumns)
        await Promise.all(columns.map(async element => {
          const obj: any = {};
          obj.di_tech_nm = element;
          obj.di_tcd = 'TR';
          try {
          //  //console.log(element,'element')
            const res = await this.getAllBusinessNamesandtype(obj);
            this.busnm_by_tech[obj.di_tech_nm] = res.di_bus_nm
            this.datatypebytech[obj.di_tech_nm] = res.datatype
            this.displayedColumnsObj[res.di_bus_nm] = obj.di_tech_nm;
            this.displayedColumns.push(res.di_bus_nm);
          
          } catch (error) {
            console.error('Error while fetching business names:', error);
            
          }
        }));
        this.dataArr = {}
        this.dataArr['unchanged'] = data;
        this.dataArr['changed'] = await this.formatData(data)

      

        this.allColumns = Array.from(this.displayedColumns);

        this.displayedColumns.push('action');
        this.dataList = this.dataArr['changed'];
        this.dataSource = new MatTableDataSource(this.dataList);
        this.filteredData = this.dataSource.data;
        this.dataSource.sort = this.sort;

        this.allColumns.forEach((column: string | number) => {
          this.columnChecked[column] = true;
        });

        this.selectedColumnsControl.setValue(this.displayedColumns.filter(column => this.columnChecked[column]));
      } else {

        const columns = this.columnsNoRecord;
        this.sortcolumns = Array.from(columns);
        await Promise.all(columns.map(async element => {
          const obj: any = {};
          obj.di_tech_nm = element;
          obj.di_tcd = 'TR';
          try {
            const res = await this.getAllBusinessNamesandtype(obj);
            this.busnm_by_tech[obj.di_tech_nm] = res.di_bus_nm
            this.datatypebytech[obj.di_tech_nm] = res.datatype
            this.displayedColumnsObj[res.di_bus_nm] = obj.di_tech_nm;
            this.displayedColumns.push(res.di_bus_nm);
          } catch (error) {
            console.error('Error while fetching business names:', error);
            // Handle error as needed, such as logging or displaying an error message
          }
        }));
        this.dataArr = {}
        this.dataArr['unchanged'] = data;
        this.dataArr['changed'] = await this.formatData(data)

        //await this.formatData(data)

        this.allColumns = Array.from(this.displayedColumns);

        this.displayedColumns.push('action');
        this.dataList = this.dataArr['changed'];
        this.dataSource = new MatTableDataSource(this.dataList);
        this.dataSource.sort = this.sort;

        this.allColumns.forEach((column: string | number) => {
          this.columnChecked[column] = true;
        });

        this.selectedColumnsControl.setValue(this.displayedColumns.filter(column => this.columnChecked[column]));

        Swal.fire({
          title: 'Warning!',
          text: 'No Record Found!',
          icon: 'warning',
          confirmButtonColor: '#4caf50',
          confirmButtonText: 'OK',
        });
      }
    } else {
      // Handle error
      Swal.fire({
        title: 'Error!',
        text: resp['data'],
        icon: 'error',
        confirmButtonColor: 'red',
        confirmButtonText: 'OK',
      });

    }
  }

  columnsNoRecord: any;
  lr_type: any;
  lr_hist: any;

  async getFields(): Promise<void> {
    try {
      let physicalFileRequest = {
        di_tech_nm: this.config.pf_name,
        di_tcd: 'PF'
      };

      let physicalFileResponse = await this.dataService.getdtls(physicalFileRequest);
      //console.log(physicalFileResponse);
      if (physicalFileResponse['error'] === false && physicalFileResponse['data'].length > 0) {
        //console.log(physicalFileResponse['data'][0]);
        let physicalFileDetails = physicalFileResponse['data'][0];

        let logicalFileRequest = {
          di_tech_nm: physicalFileDetails?.['di_tcd_json']?.['default_lf']?.['di_tech_nm'],
          di_tcd: 'LF'
        };

        let logicalFileResponse = await this.dataService.getdtls(logicalFileRequest);
        //console.log(logicalFileResponse);
        if (logicalFileResponse['error'] === false && logicalFileResponse['data'].length > 0) {
          //console.log(logicalFileResponse['data'][0]);

          let logicalRecordRequest = {
            di_tech_nm: logicalFileResponse['data'][0]?.['di_tcd_json']?.['default_lr']?.['di_tech_nm'],
            di_tcd: 'LR'
          };

          let logicalRecordResponse = await this.dataService.getdtls(logicalRecordRequest);
          //console.log(logicalRecordResponse);
          if (logicalRecordResponse['error'] === false && logicalRecordResponse['data'].length > 0) {
            //console.log(logicalRecordResponse['data'][0]['objDi']);
            let logicalRecordFields = logicalRecordResponse['data'][0]['objDi'];

            let columnNames = logicalRecordFields.map((field: any) => field['di_tech_nm']);
            //console.log(columnNames);
            this.columnsNoRecord = columnNames;
            //console.log(logicalRecordFields);
            this.lr_type = logicalRecordResponse['data'][0]?.['di_tcd_json']?.['lr_type'];
            this.lr_hist = logicalRecordResponse['data'][0]?.['di_tcd_json']?.['lr_hist'];
            //console.log(this.lr_type);
            //console.log(this.lr_hist);
            //console.log(this.columnsNoRecord, this.displayedColumns)

            // await this.getFieldDtls(columnNames);
          } else {
            console.error('Error fetching logical record details:', logicalRecordResponse['error'] || 'No data found');
          }
        } else {
          console.error('Error fetching logical file details:', logicalFileResponse['error'] || 'No data found');
        }
      } else {
        console.error('Error fetching physical file details:', physicalFileResponse['error'] || 'No data found');
      }
    } catch (error) {
      console.error('An error occurred in getFields:', error);
    }
  }

  // async formatData(data:any){
  //     data.map((element)=>{
  //       // if(this.datatypebytech[element['di_tech_nm']]=='datetime' ||this.datatypebytech[element['di_tech_nm']]=='date' ){
  //       //   this.dataService.formatTime(element?.di_tech_nm) 
  //       // }
  //       //console.log(element,'element');
  //       ////console.log(this.datatypebytech[element['di_tech_nm']],'ggg');
  //       //console.log(Object.keys(element))


  //     })
  // }

  async formatData(objects: any) {
    const formattedObjects = [];

    objects.forEach(obj => {
      const formattedObj = {};

      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {

          if (obj[key] != null && obj[key] != undefined && obj[key] != "") {
            //  //console.log(this.datatypebytech[key], key)
            if ((this.datatypebytech[key]).toLowerCase() == 'datetime' || (this.datatypebytech[key]).toLowerCase() == 'date') {

              formattedObj[key] = (key != 'valid_upto') ? this.dataService.formatTime(obj[key]) : obj[key];
            } else if ((this.datatypebytech[key]).toLowerCase() == 'json') {
              formattedObj[key] = JSON.stringify(obj[key], null, 2)

            } else {
              formattedObj[key] = obj[key];
            }
          } else {
            formattedObj[key] = obj[key];
          }
        }
      }

      formattedObjects.push(formattedObj);
    });

    return formattedObjects;
  }
  private isNumericType(dataType: string = 'String'): boolean {
    return dataType === 'integer' || dataType === 'decimal';
  }


  toggleColumnVisibility(column: string) {
    if (this.columnChecked[column]) {
      //this.displayedColumns.push(column);
      this.displayedColumns.unshift(column);
    } else {
      const index = this.displayedColumns.indexOf(column);
      if (index !== -1) {
        this.displayedColumns.splice(index, 1);
      }
    }
  }

  async getAllBusinessNamesandtype(obj: any) {
    let req_obj: any = new Object()
    req_obj['act_id'] = this.act_id;
    req_obj['di_tech_nm'] = obj['di_tech_nm']
    req_obj['di_tcd'] = obj['di_tcd']
    req_obj['pf_path'] = this.pf_path
    req_obj['pf_name'] = this.pf_name
    req_obj['app_cd'] = this.config.app_cd
    ////console.log(req_obj);


    let resp: any = await this.dataService.getBusinessName(req_obj)
    ////console.log(resp);
    if (resp['error'] == false) {
      let data = resp['data']
      ////console.log(data);
      return data[0];



    }
    else {
      return 0;
    }

  }

  onPrintAllClick() {

  }

  // onAddButtonClick() {
  //   const navigationExtras: NavigationExtras = {
  //     queryParams: { table_nm: this.table_nm, pf_path: this.pf_path, pf_name: this.pf_name },
  //     skipLocationChange: true
  //   };

  //   this.router.navigate(['/home/rrv'], navigationExtras);
  // }

  async onAddButtonClick() {
    if (this.config.crudconfig) {
      await this.addcontrolgiventoapp('create', {})
    }
    else {
      await this.rrvConfig('create', {})
    }


  }
  async addcontrolgiventoapp(mode: any, formData: any) {
    const routePath = `./${this.config.crudconfig?.route}`;
    let itemObj = window.btoa(JSON.stringify({
      pf_path: this.pf_path,
      pf_name: this.pf_name,
      app_cd: this.config.app_cd,
      header: this.config.header,
      mode: mode,
      formData: formData



    }))
    this.router.navigate([routePath], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
  }
  async rrvConfig(mode: any, formData: any) {
    let itemObj = window.btoa(JSON.stringify({
      pf_path: this.pf_path,
      pf_name: this.pf_name,
      app_cd: this.config.app_cd,
      header: this.config.header,
      mode: mode,
      formData: formData



    }))
    this.router.navigate(['./rrv'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });
  }
  isEqualDynamic(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Check if both objects have the same number of keys (excluding ignored types)
    const filteredKeys1 = keys1.filter(key => !this.isIgnoredType(this.datatypebytech[key]));
    const filteredKeys2 = keys2.filter(key => !this.isIgnoredType(this.datatypebytech[key]));

    if (filteredKeys1.length !== filteredKeys2.length) {
      return false;
    }

    // Check if all key-value pairs are the same, ignoring specified types
    return filteredKeys1.every(key => obj2.hasOwnProperty(key) && obj1[key] === obj2[key]);
  }

  // Helper function to check if the datatype should be ignored
  isIgnoredType(type) {
    const lowerType = type.toLowerCase();
    return lowerType === 'datetime' || lowerType === 'date' || lowerType === 'json';
  }

  async onUpdate(element: any) {
    //console.log(element)


    let eletogo = this.dataArr['unchanged'].find(obj => this.isEqualDynamic(obj, element));
    //console.log(eletogo)

    //await this.rrvConfig('update', eletogo)
    if (this.config?.crudconfig?.route) {
      await this.addcontrolgiventoapp('update', eletogo)
    }
    else if (this.config?.crudconfig?.updateEvent) {
      await this.raiseOnUpdateClickEvent(eletogo)
    }
    else {
      await this.rrvConfig('update', eletogo)
    }
  }
  async onView(element: any) {
    let eletogo = this.dataArr['unchanged'].find(obj => this.isEqualDynamic(obj, element));
    //console.log(eletogo)

    // await this.rrvConfig('update', eletogo)

    //  await this.rrvConfig('view', eletogo)

    if (this.config?.crudconfig?.route) {
      await this.addcontrolgiventoapp('view', eletogo)
    }
    else if (this.config?.crudconfig?.viewEvent) {
      await this.raiseOnViewClickEvent(eletogo)
    }
    else {
      await this.rrvConfig('view', eletogo)
    }


  }
  async raiseOnUpdateClickEvent(element: any) {
    this.onUpdateItemEvent.emit(element)
  }
  async raiseOnViewClickEvent(element: any) {
    this.onViewItemEvent.emit(element)

  }
  async onDelete(element: any) {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to delete the Item`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });
    if (result.isConfirmed) {
      await this.deleteFinal(element)
    }
  }
  async deleteFinal(element: any) {
    let pk = []
    //console.log(element);
    let res = await this.dataService.PrimaryKey({
      pf_path: this.pf_path,
      pf_name: this.pf_name,
      app_cd: 'DD',

    })
    if (res['error'] == false) {
      pk = res['data'][0]['PK']
      //console.log(pk);
      let where: any = {
        "and": [

        ]
      }
      pk.filter((item) => {
        for (let key in element) {
          if (item == key) {
            const obj = { [key]: element[key] };
            where.and.push(obj);
            break;
          }
        }

      })
      //console.log(where)
      this.dataService.deleteData({ pf_path: this.pf_path, pf_name: this.pf_name, app_cd: this.config.app_cd, where: where }).then(response => {
        ////console.log('Data added successfully:', response);

        Swal.fire({
          title: 'Success!',
          text: 'Record deleted successfully!',
          icon: 'success',
          confirmButtonColor: '#4caf50',
          confirmButtonText: 'OK',
        });

        this.getAllData();

      }).catch(error => {
        console.error('Error deleting data:', error);
      });

    }
    else {

    }

  }





  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllData();
  }
  Pagesizechange(size: number) {
    this.pageSize = size
    //console.log(this.pageSize);

  }
  sortingCriteria: string[] = [];
  orderArr: any = []
  currentSortingCriteria: any
  openMultipleSortingDialog(): void {
    //console.log(this.sortcolumns);

    const dialogRef = this.dialog.open(MultipleSortingDialogComponent, {
      width: '400px',
      data: { allColumns: this.sortcolumns, displayedColumnsObj: this.busnm_by_tech, currentSortingCriteria: this.currentSortingCriteria } // Pass all available columns to the dialog
    });

    dialogRef.componentInstance.applySorting.subscribe((obj: any) => {
      // //console.log(sortingCriteria);
      this.currentSortingCriteria = obj.preserveState
      this.orderArr = obj.order
      if (this.orderArr && this.orderArr.length > 0) {
        this.getAllData()
      }

    });
  }
  currentfilterCriteria: any
  filterArr: any
  openFilterbyDialog(): void {
    //console.log(this.sortcolumns);

    const dialogRef = this.dialog.open(FilterByComponent, {
      width: '700px',
      data: { allColumns: this.sortcolumns, displayedColumnsObj: this.busnm_by_tech, currentfilterCriteria: this.currentfilterCriteria } // Pass all available columns to the dialog
    });

    dialogRef.componentInstance.applyFiltering.subscribe((obj: any) => {
      //  //console.log(sortingCriteria);
      this.currentfilterCriteria = obj.preserveState
      // obj.filter.forEach((ele)=>{

      // }
      // )
     if(obj?.filter.length>0)
      this.filterArr['or'] = obj?.filter
      if (this.filterArr) {
        this.getAllData()
        // this.getTotalnoofitems()
      }


    });
  }
  clearFilters(): void {
   delete this.filterArr['or']
   this.currentfilterCriteria=[]
   // Clear the filter array
    this.getAllData()
    //console.log('Filters cleared');
  }
  async reset() {
    this.filterArr = {}
    this.orderArr = []
    this.currentfilterCriteria = []
    this.currentSortingCriteria = []
    this.totalItems = 0;
    this.cardsObj = {}
    this.tableview = true
    this.cardsview = false;
    this.columnsNoRecord = []
    this.displayedColumns = []
    this.filteredData=[]

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    //console.log(this.dataSource.filter);

  }
  applyFiltermatcard(filterValue: string) {
    const filter = filterValue.trim().toLowerCase();

    // Filter logic based on card properties
    this.filteredData = this.dataSource.data.filter((card: any) => {
      return (
        (card[this.cardsObj.mainHeading]?.toLowerCase().includes(filter)) ||
        (card[this.cardsObj.subHeading]?.toLowerCase().includes(filter)) ||
        (card[this.cardsObj.actionAreaLeft]?.toLowerCase().includes(filter)) ||
        (card[this.cardsObj.actionAreaMid]?.toLowerCase().includes(filter))
      );
    });

    //console.log('Filtered Data:', this.filteredData);  // Logging filtered data
  }
  changeView() {
    this.tableview = !this.tableview
  }
  showOverlay: boolean = false;

  toggleOverlay(event: MouseEvent) {
    event.stopPropagation();
    this.showOverlay = !this.showOverlay;
  }




}
